import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> ASP eSign Audit </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>ASP eSign Audit</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  An ASP eSign Audit ensures that your Application Service
                  Provider (ASP) electronic signature solution is secure,
                  compliant, and trustworthy. With businesses relying heavily on
                  digital signatures for contracts, approvals, and legal
                  documents, it’s critical to verify that your eSign platform
                  follows regulatory standards, prevents misuse, and guarantees
                  authenticity. At [Your Company Name], we conduct comprehensive
                  ASP eSign Audits to evaluate security, compliance, and
                  operational effectiveness, giving organizations confidence in
                  their digital transactions.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-arrows-down-to-people"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Regulatory Compliance </h3>
                    <p>
                      Ensure alignment with IT Act, CCA guidelines, eIDAS, and
                      global digital signature standards.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-database"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Trust & Integrity </h3>
                    <p>
                      Guarantee authenticity, confidentiality, and
                      non-repudiation of signed documents.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-shield-halved"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Fraud Prevention </h3>
                    <p>
                      Detect and mitigate risks of identity theft, unauthorized
                      use, and signature forgery.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-table"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Customer Confidence </h3>
                    <p>
                      Strengthen credibility by showcasing secure and compliant
                      eSign processes.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-business-time"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Operational Assurance </h3>
                    <p>
                      Verify that the platform performs reliably under different
                      business scenarios.
                    </p>
                  </div>
                </div>
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "methodology" ? " active" : ""}`}
                        onClick={() => setActiveTab("methodology")}
                      >
                        Methodology
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "keybenefits" ? " active" : ""}`}
                        onClick={() => setActiveTab("keybenefits")}
                      >
                        Key Benefits
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "deliverables" ? " active" : ""}`}
                        onClick={() => setActiveTab("deliverables")}
                      >
                        Deliverables
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content" id="ex2-content">
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      id="methodology"
                      role="tabpanel"
                    >
                      <p>Our ASP eSign Audit includes:</p>
                      <ul>
                        <li>
                          <b>Scope Definition :-</b>Understand ASP services,
                          digital signature workflows, and usage.
                        </li>
                        <li>
                          <b>Policy & Control Review :-</b>Assess compliance
                          with IT Act, CCA, and certification authority
                          standards.
                        </li>
                        <li>
                          <b>Technical Evaluation :-</b> Audit infrastructure,
                          authentication methods, encryption, and API security.
                        </li>
                        <li>
                          <b>Process Validation :-</b> Validate identity
                          verification, signing workflows, and audit trails.
                        </li>
                        <li>
                          <b>Data Security Review :-</b> Evaluate data storage,
                          transmission, and retention policies.
                        </li>
                        <li>
                          <b>Simulation & Testing :-</b>
                          Perform test cases for signature validation and
                          forgery resistance.
                        </li>
                        <li>
                          <b>Compliance Mapping :-</b>
                          Map audit findings with regulatory requirements.
                        </li>
                        <li>
                          <b>Final Audit Report :-</b>
                          Provide recommendations and remediation steps for
                          strengthening compliance.
                        </li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      id="keybenefits"
                      role="tabpanel"
                    >
                      <ul>
                        <li>
                          Ensure ASP compliance with IT Act & CCA guidelines.
                        </li>
                        <li>Build customer and regulator trust.</li>
                        <li>Reduce fraud and unauthorized signature risks.</li>
                        <li>
                          Strengthen data protection and encryption controls.
                        </li>
                        <li>Gain audit-ready compliance documentation.</li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      id="deliverables"
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>ASP eSign Security & Compliance Report</li>
                        <li>Risk & Control Gap Analysis</li>
                        <li>
                          Compliance Mapping Report (IT Act, CCA, eIDAS, etc.)
                        </li>
                        <li>Audit Trail Validation & Review</li>
                        <li>Remediation Roadmap with Prioritized Actions</li>
                        <li>
                          Final ASP eSign Audit Report & Executive Summary
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ----------*/}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li>
                      <b>Certified Auditors :-</b> Expertise in CCA compliance,
                      PKI infrastructure, and ASP frameworks.
                    </li>
                    <li>
                      <b>End-to-End Coverage :-</b> Review across security,
                      compliance, process, and technology layers.
                    </li>
                    <li>
                      <b>Global Standards Alignment :-</b> – Ensure compliance
                      with IT Act, CCA guidelines, and international
                      regulations.
                    </li>
                    <li>
                      <b>Proven Experience :-</b> Trusted partner for ASPs,
                      enterprises, and government bodies.
                    </li>
                    <li>
                      <b>Tailored Recommendations :-</b>
                      Industry-specific guidance for BFSI, legal, healthcare,
                      and SaaS sectors.
                    </li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------*/}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
